@if (showUtilityBar) {
  <div class="utility-bar ub tw:block" [ngClass]="{'expanded': utilityBarExpanded}">
    <div #templateContainer class="utility-bar__panel" [ngClass]="{'hide-panel': !utilityBarExpanded}">
      <ng-container *ngTemplateOutlet="templateRef"></ng-container>
    </div>
  </div>
    }
